/** Generate log names for UXA. Keeping this here so that it can be used internally for waffle but also in metaserver */
export const generateGHLogName = (subComp, selectedItem) => {
    const modifier = selectedItem ? `select-${selectedItem}` : 'trigger';
    return `gh_${subComp}_${modifier}`;
};
